import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { paths } from '@platform/paths';
import { WidgetHeaderComponent } from '../widget-header/widget-header.component';

@Component({
  selector: 'cp-widget-minimal-data',
  imports: [CommonModule, RouterLink, WidgetHeaderComponent],
  templateUrl: './widget-minimal-data.component.html',
  styleUrls: ['../../shared/widget.scss', './widget-minimal-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetMinimalDataComponent {
  buttonUrl = ['/' + paths.PLATFORM, paths.platform.PROFILE, paths.platform.profile.INCOME];
}
